import { render, staticRenderFns } from "./snakeDailyLimit.vue?vue&type=template&id=1d3b308a&"
import script from "./snakeDailyLimit.vue?vue&type=script&lang=js&"
export * from "./snakeDailyLimit.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./snakeDailyLimit.vue?vue&type=style&index=1&id=1d3b308a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports